export default function getMfeCacheBuster() {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;

  return `${date.getDate()}${date.getHours()}${nearestQuarterHour}`;
}
